import {columnData, statusPillRender} from "./initialData.js";
import LookupTable from "../../components/lookupTable";
import {isPresent, merge} from "../../utilities/general";
import modalHtml   from "../../sharedHtml/modal.html";
import modalBody from "./html/exportBody.html";
import modalFooter from "./html/exportFooter.html";
import render from "../../utilities/render";
const _ = require("underscore");
import {buildExport, readSpecificKeyFromSearchCriteria,alterSearchCriteriForController, pushFilterSessionCacheState} from "../../utilities/filtersutil";
import {SUCCESS_MODAL_TIMEOUT} from "../../constants";

export default function attachBulkUploadDataTable(targetSelector){
    // START: REQUIRED TO LOAD STUB
   const outerEl = $(targetSelector);
   const exportBtn = outerEl.find('.btn-export');
   //const exportModal = $("#exportModal");
  
   

  // const entryEl = $("<div class='entry-point'></div>");
   const mainEl = outerEl.find('.bulk-upload-datatable');
  // outerEl.html(entryEl);
  // entryEl.append(mainEl);
  const itemData = mainEl.data('bulkupload-records');
  const filterData = mainEl.data('filter-dta');

  const generateExportUrl  =  mainEl.data("export-url");
  const onFetchUrl = mainEl.data('onfetch-url');
  const exportModal = $(render(modalHtml,
      {
        title: 'Export bulk upload',
        leftAlignTitle: true,
        modalDialogClass: "q-modal-dialog-500",
        body: render(modalBody),
        topCloseBtn: true,
        autoHideTop: true,
        footerBtns: render(modalFooter)
        
      }
    ));

    outerEl.append(exportModal);
    const exportModalButton = exportModal.find(".modalExportData");
    const dataFileType = exportModal.find("#dataFileType");
  let bulkLookupTable = new LookupTable({
    target: $(".bulk-upload-table"),
    minWidthClass: "q-min-width-md-til-md",
    mobileColumns: [
      {
        data: "bupDisplayId",
        title: "Upload ID",
        linkKey: "lookupTableActionLink"
      },
      {
        data: "type",
        title: "Upload Type"
      },
      {
        data: "status",
        title: "Status",
        render: statusPillRender
      }
    ],
    tableFilters: {
      data: filterData
    },
    tableSearchInput: {
      placeholder: 'Search Upload ID or Upload Type or Bulk Display Id'
    },
    tableSearchDropdown: {
      columns: [
        {
          data: "bupDisplayId",
          title: "Upload ID",
          value: "bupDisplayId"
        },
        {
          data: "type",
          title: "Upload Type",
          value: "type"
        },
        
      ]
    },
    dataTable: {
      order: [
          [3, 'desc'],
      ],
      data: itemData.bulkUpload,
      columns: columnData
      
    },
     tableColumnModal: {
      data: columnData
    },
    paginationData: {
      size: itemData.bulkUpload.length,
      number: itemData.pageNumber,
      totalElements: itemData.totalElements,
      totalPages:itemData.totalPages
    },
    filterModal: {
      title: "Filter Bulk Uploads",
      tableType: "inbound shipments"
    },
    onFetch: function() {
      
    bulkLookupTable.showLoadingOverlay();
      let currentData = bulkLookupTable.generateData();
      let size= 10;
      if(!isNaN(currentData["size"])){
        size = currentData["size"];
      }
      let tempUrl = onFetchUrl+"&size="+size;
      
       setTimeout(() => {$.ajax({
        url:buildUrl(currentData, tempUrl),
        success: function(data){
          data =  JSON.parse(data);
          bulkLookupTable.setNewData(data.bulkUpload);
          bulkLookupTable.setPaginationData({
          number: data.pageNumber,
          totalElements: data.totalElements,
          totalPages:data.totalPages,
          size:size
        });
          bulkLookupTable.hideLoadingOverlay();
          pushFilterSessionCacheState();
        },
        error: function(error){
          bulkLookupTable.hideLoadingOverlay();
        }
       });
       },SUCCESS_MODAL_TIMEOUT);
    }

  });
  bulkLookupTable.init();

  function buildUrl(currentData, baseUrl){
    let startDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'startDate');
    let endDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'endDate'); 
    let fixedRangeDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'fixedRange'); 
    let revisedSearchCriteria =  alterSearchCriteriForController(currentData["searchCriteria"]);
    let orderBy =  currentData["orderBy"] == 'ordStatus' ? "ordStatusCode" : currentData["orderBy"];
    let pageNumber = isPresent(currentData["number"]) ? currentData["number"] : 0;
    let dateRange ="";
    let searchCriteria =   _.toArray(revisedSearchCriteria).length > 0 ? JSON.stringify(_.toArray(revisedSearchCriteria)) : _.toArray(revisedSearchCriteria);
    
      if(isPresent(startDate)){
        dateRange = dateRange + "&startDate="+startDate;
      }
      if(isPresent(endDate)){
       dateRange= dateRange +  "&endDate="+endDate; 
      }
      if(orderBy == 'type'){
          orderBy = 'bupUploadType';
      }

      if(orderBy == 'status'){
          orderBy = 'bupStatus';
      }

      if(orderBy == 'createdTimeStamp'){
          orderBy = 'bupCreatedDate';
      }

       if(orderBy == 'bulkUploadId'){
          orderBy = 'bupId';
      }

      
      return baseUrl+dateRange+"&fixedRange="+fixedRangeDate+"&orderBy="+orderBy+"&orderByType="+currentData["sortType"]+"&searchCriteria="+searchCriteria + "&page="+pageNumber;
  }


  exportBtn.on('click', function(e){
      e.preventDefault();
      exportModal.modal("show");

  });

  exportModalButton.click(function() {
    exportModal.modal("hide");
    let fileType = dataFileType.val();
    exportToFile(fileType);
  });

  dataFileType.change(function() {
    exportModalButton.attr('disabled', false);
  });

  let exportToFile = function(fileType) {
   let currentData = bulkLookupTable.generateData();
   let tempUrl = generateExportUrl + "&fileType="+ fileType + "&size=1000";
  
    let url = buildUrl(currentData,tempUrl );
    window.open(url);
  }; 

}


// WEBPACK FOOTER //
// ./src/pages/bulkUpload/bulkUploadDataTable.js